const Storage = {
    get(k) {
        try {
            return JSON.parse(localStorage.getItem(k));
        } catch (e) {
            return null;
        }
    },
    set(k, v) {
        localStorage.setItem(k, JSON.stringify(v));
    },
    remove(k){
        localStorage.removeItem(k);
    },
    clearAll(){
        localStorage.clear()
    }
};

module.exports = Storage;


// WEBPACK FOOTER //
// ./src/util/Storage.js